import * as Yup from 'yup';

const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export const loginValidationSchema = Yup.object({
    email: Yup.string().trim().required('Email is required'),
    password: Yup.string().trim().required('Password is required'),
});
